export var deviceSize = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptopS: 1024,
    laptopL: 1280,
    desktop: 1440,
};
export var mediaQueries = {
    mobileS: "@media (min-width: ".concat(deviceSize.mobileS, "px)"),
    mobileM: "@media (min-width: ".concat(deviceSize.mobileM, "px)"),
    mobileL: "@media (min-width: ".concat(deviceSize.mobileL, "px)"),
    tablet: "@media (min-width: ".concat(deviceSize.tablet, "px)"),
    laptopS: "@media (min-width: ".concat(deviceSize.laptopS, "px)"),
    laptopL: "@media (min-width: ".concat(deviceSize.laptopL, "px)"),
    desktop: "@media (min-width: ".concat(deviceSize.desktop, "px)"),
};
